import React, { Component } from "react";
import { Link } from "react-router-dom";
import {AiOutlineCloseCircle, AiOutlineMenuUnfold} from 'react-icons/ai'

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
  }

  toggle = () => {
    this.setState({open: !this.state.open})
  }
  render() {
    return (
      <div className="nav">
        <div className="logo-img">
          <Link to="/">
            <img src="images/logo.jpg" alt="" />
          </Link>
        </div>
        <ul style={{ top: this.state.open ? "60px" : "-1200%" }}>
          <li>
            <Link onClick={this.toggle} to="about">About</Link>
          </li>
          <li>
            <Link onClick={this.toggle} to="skills">Skills</Link>
          </li>
          <li>
            <Link onClick={this.toggle} to="experience">Experience</Link>
          </li>
          <li>
            <Link onClick={this.toggle} to="sites">My sites</Link>
          </li>
          <li>
            <Link onClick={this.toggle} to="goals">Goals</Link>
          </li>
        </ul>
        <div onClick={this.toggle} className="menuToggle">
          {this.state.open ? <AiOutlineCloseCircle /> : <AiOutlineMenuUnfold />}
        </div>
      </div>
    );
  }
}

export default Nav;
